const getters = {
  /**
   * User is authenticated.
   *
   * @param state
   * @returns {boolean}
   */
  authenticated(state) {
    return !!state.accessToken && !state.accessTokenExpired;
  },

  /**
   * User has address
   *
   * @param state
   * @returns {boolean}
   */
  userHasAddress(state) {
    return !!(state.user.zip
      && state.user.state
      && state.user.city
      && state.user.street
      && state.user.number
      && state.user.district);
  },
};

export default getters;
